import { useStoryblokState, StoryblokComponent as SBComponent } from "@storyblok/react";

const previewMode = typeof window !== 'undefined' ? window.location !== window.parent.location : false;

const StoryblokComponent = ({ story: initialStory }) => {
  const story = useStoryblokState(initialStory, {}, previewMode);

  if (!story.content) return null;

  return <SBComponent blok={story.content} />;
};

export default StoryblokComponent;
